import styled from 'styled-components'

export const FooterContainer = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 16px;
  background-color: white;
  gap: 32px;

  img {
    width: 303px;
    height: 58px;
  }

  @media (max-width: 791px) {
    padding: 16px;
    gap: 16px;
    img {
      width: 170px;
      height: 32px;
    }
    h5 {
      font-size: 12px;
      line-height: 18px;
    }
  }
`
